<template>
  <d-data-table
    fluid
    resource="application-files"
    :url="$laravel.route(`api.application-files.index`, property.id)"
    searchable
    no-padding
    :edit-url="(row) => `/properties/${property.id}/application-files/${row.id}/edit`"
    :show-button="true"
  >
    <b-table-column
      v-slot="props"
      field="created_at"
      sortable
      :label="$t('created_at').capitalize()"
    >
      <p>
        {{ $dayjs(props.row.created_at).format('LL') }}
      </p>
    </b-table-column>
    <b-table-column
      v-slot="props"
      field="applicants"
      :label="$t('applicant_names')"
      sortable
    >
      <div v-if="props.row.applicants && props.row.applicants.length">
        <p
          v-for="applicant in props.row.applicants"
          :key="applicant.id"
          class="tag is-info is-light is-rounded"
        >
          {{ applicant.first_name }} {{ applicant.last_name }}
        </p>
      </div>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="status"
      :label="$t('status').capitalize()"
      sortable
    >
      <p class="tag is-info is-light is-rounded">
        {{ props.row.status_label }}
      </p>
    </b-table-column>

    <b-table-column
      v-slot="props"
      field="status_progress"
      sortable
      :label="$t('status_progress').capitalize()"
    >
      <p>
        {{ props.row.status_progress }}
      </p>
    </b-table-column>
  </d-data-table>
</template>



<script>

export default {
  props: {
    property: {
      required: true,
      type: Object,
    },
  },
};

</script>
